import { render, staticRenderFns } from "./FooterPC.vue?vue&type=template&id=81701ce4&scoped=true"
import script from "./FooterPC.vue?vue&type=script&lang=js"
export * from "./FooterPC.vue?vue&type=script&lang=js"
import style0 from "./FooterPC.vue?vue&type=style&index=0&id=81701ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81701ce4",
  null
  
)

export default component.exports